import React from "react";
import "./index.scss";
import ArrowRight from "../../assets/right.svg";
import JustLend from "../../assets/just-lend.png";
import FeeeIO from "../../assets/feee-io.png";
import t from "../../locales";
import { getAccounts } from "lib/sdk";

type ItemProps = Record<string, string>;

const Item = ({ title, to, icon, slogan }: ItemProps) => {
  const onClick = async () => {
    const wallet_address = (await getAccounts())[0]

    gtag(
      'event',
      'tron_resource_convert',
      {
        actionType: "click",
        caip2: "tip174:00000000000000001ebf88508a03865c",
        wallet_address,
        url: to,
        title
      }
    )
  }
  return (
    <div className="item">
      <div className="icon">
        <img src={icon} alt={title} />
      </div>
      <a className="inner" href={to} onClick={onClick}>
        <div className="desc">
          <div className="title">{title}</div>
          <div className="slogan">{slogan}</div>
        </div>
        <div className="arrow-wrap">
          <img className="arrow" src={ArrowRight} alt="right" />
        </div>
      </a>
    </div>
  );
}

export const OtherOptions = () => {
  const links = [
    {
      title: "JustLend DAO",
      to: "https://app.justlend.org/energy?utm_source=imtoken&utm_medium=referral",
      icon: JustLend,
      slogan: t('link_justlend_desc'),
    },
    {
      title: "Feee.io",
      to: "https://feee.io/b2c?ic=imtoken&utm_source=imtoken&utm_medium=referral",
      icon: FeeeIO,
      slogan: t('link_feeeio_desc'),
    },
  ];

  return (
    <div className="container">
      <h2 className="title">{t('title_rent_resource')}</h2>
      <div className="list">
        {links.map((link, index) => (
          <Item
            title={link.title}
            to={link.to}
            icon={link.icon}
            slogan={link.slogan}
          />
        ))}
      </div>
    </div>
  );
};
